export default tagData =>
  tagData.reduce(
    (prev, curr) => {
      const ret = { ...prev };
      let index = ret.indexes.indexOf(curr.tagGroup.name);
      if (index === -1) {
        ret.indexes = [...ret.indexes, curr.tagGroup.name];
        index = ret.indexes.length - 1;
        ret.groups = [...ret.groups, curr.tagGroup];
        ret.groups[index].tags = [];
      }
      ret.groups[index].tags = [...ret.groups[index].tags, curr];
      return ret;
    },
    { indexes: [], groups: [] }
  );



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/tagsToGroups.js